var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChatTeardropText = function SvgIconChatTeardropText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.375 4a7.625 7.625 0 0 0-7.625 7.625v7.625h7.625a7.625 7.625 0 1 0 0-15.25m-6.806.82a9.625 9.625 0 1 1 6.806 16.43H4.477a1.713 1.713 0 0 1-1.727-1.727v-7.898c0-2.553 1.014-5 2.82-6.806m2.806 5.305a1 1 0 0 1 1-1H15a1 1 0 0 1 0 2H9.375a1 1 0 0 1-1-1m0 3.75a1 1 0 0 1 1-1H15a1 1 0 0 1 0 2H9.375a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconChatTeardropText;